module.exports = __webpack_public_path__ + "media/images/chevron-up-80d42320a4451527d93ea3a8663a93f9.svg";